import { useRouter } from 'next/router'
import { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

type CardPelaksanaan2026Props = {
  documentFlowStatus: 'DISABLED' | 'OLD_DOCUMENT_FLOW' | 'NEW_DOCUMENT_FLOW'
  isReadyForPelaksanaan?: boolean
  filledBySystem?: boolean
  isPraktikKinerjaDone?: boolean
  isPengembanganKompetensiDone?: boolean
  isTugasPokokDone?: boolean
}
const CardPelaksanaan2026 = ({
  documentFlowStatus,
  filledBySystem,
  isReadyForPelaksanaan,
  isPraktikKinerjaDone,
  isPengembanganKompetensiDone,
  isTugasPokokDone,
}: CardPelaksanaan2026Props) => {
  const { trackEvent } = useSKPPelaksanaanTrackEvent()
  const router = useRouter()

  const menuItems: Array<{
    icon: string | null
    title: string
    buttonLabel: string
    buttonColor: 'black' | 'white'
    disabled?: boolean
    href?: string
    onClick?: () => void
  }> = useMemo(
    () => [
      {
        icon: assetUrl('/illustrations/img-badge-star-ribbon-pro.png'),
        title:
          documentFlowStatus === 'OLD_DOCUMENT_FLOW'
            ? 'Tugas Tambahan'
            : 'Pelaksanaan Tugas Pokok',
        buttonLabel: isTugasPokokDone ? 'Cek' : 'Lakukan',
        buttonColor: isTugasPokokDone ? 'white' : 'black',
        disabled: !isReadyForPelaksanaan || documentFlowStatus === 'DISABLED',
        href: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/${
          documentFlowStatus === 'OLD_DOCUMENT_FLOW'
            ? 'tugas-tambahan'
            : 'tugas-pokok'
        }`,
      },
      {
        icon: assetUrl('/illustrations/img-badge-star.png'),
        title: filledBySystem
          ? 'Praktik Kinerja Anda telah diselesaikan oleh sistem'
          : 'Praktik Kinerja',
        disabled: !isReadyForPelaksanaan || filledBySystem,
        buttonLabel: isPraktikKinerjaDone ? 'Cek' : 'Lakukan',
        buttonColor: isPraktikKinerjaDone ? 'white' : 'black',
        onClick: () => {
          trackEvent({
            activity_type: 'pelaksanaan_click_cek_langkah_observasi',
            screen_name: 'homepage_pengelolaan',
          })
          router.push(`${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/beranda`)
        },
      },
      {
        icon: assetUrl('/illustrations/img-document.png'),
        title: 'Pengembangan Kompetensi',
        buttonLabel: isPengembanganKompetensiDone ? 'Cek' : 'Lakukan',
        buttonColor: isPengembanganKompetensiDone ? 'white' : 'black',
        disabled: !isReadyForPelaksanaan || documentFlowStatus === 'DISABLED',
        href: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/pengembangan-kompetensi`,
      },
      {
        icon: null,
        title: 'Perilaku Kerja',
        buttonLabel: 'Cek',
        buttonColor: 'white',
        href: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/perilaku-kerja`,
      },
    ],
    [
      documentFlowStatus,
      isTugasPokokDone,
      isReadyForPelaksanaan,
      filledBySystem,
      isPraktikKinerjaDone,
      isPengembanganKompetensiDone,
      trackEvent,
      router,
    ]
  )

  return (
    <>
      <div className="p-6">
        <div className="space-y-4">
          {menuItems.map((item) => (
            <div
              key={item.title}
              className="flex items-center justify-between p-4 border border-gray-30 rounded-lg"
            >
              <div className="flex items-center gap-4">
                {item.icon && (
                  <img src={item.icon} alt="" width={64} height={64} />
                )}
                <Text variant="heading-sm">{item.title}</Text>
              </div>
              <Button
                color={item.buttonColor}
                fullWidth
                className="max-w-44"
                disabled={item.disabled}
                onClick={() => {
                  if (item.href) {
                    router.push(item.href)
                  } else if (item.onClick) {
                    item.onClick()
                  }
                }}
              >
                {item.buttonLabel}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default CardPelaksanaan2026
